export const isShallowEqual = (
  opt1: object | undefined,
  opt2: object | undefined,
): boolean => {
  return JSON.stringify(opt1) === JSON.stringify(opt2);
};
